import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Theme, useTheme } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { useAtomicStyles } from "styles";
import { useDispatch, useSelector } from "react-redux";
import { actions, selectors } from "redux-store";
import { LimitationType } from "../../redux-store/slices/merchant/interfaces";
import { useCurrentMerchantId, useTypedTranslations } from "../../hooks";
import { getAjaxIsLoadingByApi } from "../../redux-store/slices/ajax/selectors";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    gridContainer: {
      display: "flex",
      flexDirection: "row-reverse",
    },
    datagridButton: {
      margin: 0,
      marginRight: "1em",
      marginBottom: "0.4em",
    },
    filterButton: {
      fontSize: "0.8rem",
      color: "#673368",
      marginBottom: "0.2em",
    },
  }),
);

const useNotificationToolbar = () => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const classes = useMemo(() => ({}), []);
  const atomicStyles = useAtomicStyles();
  const merchantId = useCurrentMerchantId();
  const isLoading = useSelector(
    getAjaxIsLoadingByApi(actions.getMerchantsUsagesByMerchantId.api),
  );
  const usages = useSelector(selectors.getMerchantUsages);
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const filter = useSelector(selectors.getFilterType);
  const [t] = useTypedTranslations();

  const handleMenuOpen = useCallback(
    (ev: React.MouseEvent<HTMLButtonElement>) => {
      setAnchorEl(ev.currentTarget);
    },
    [setAnchorEl],
  );

  const handleMenuClose = useCallback(() => {
    setAnchorEl(null);
  }, [setAnchorEl]);

  const handleSendNotificationDialogOpen = useCallback(() => {
    dispatch(actions.setIsNotificationDialogOpen(true));
  }, [dispatch]);

  const setTypeFilter = useCallback(
    (type: "Tutte" | "Test" | "Produzione") => {
      dispatch(actions.setFilterType(type));
      setAnchorEl(null);
    },
    [dispatch],
  );

  useEffect(() => {
    dispatch(actions.getMerchantsUsagesByMerchantId.request({ merchantId }));
  }, [dispatch, merchantId]);

  const data = useMemo(() => {
    if (usages) {
      const data = {
        isDisabled: false,
        message: "",
      };
      usages.forEach((u) => {
        if (u.limitation.type === LimitationType.Notification) {
          if (u.currentValue >= u.limitation.threshold) {
            data.isDisabled = true;
            data.message =
              "Hai superato il limite di notifiche consentito dal tuo piano di abbonamento";
          }
        } else if (u.limitation.type === LimitationType.Device) {
          if (u.currentValue >= u.limitation.threshold) {
            data.isDisabled = true;
            data.message =
              "Hai superato il limite di device consentito dal tuo piano di abbonamento";
          }
        }
      });
      return data;
    }
  }, [usages]);

  return {
    styles,
    classes,
    atomicStyles,
    handleSendNotificationDialogOpen,
    handleMenuClose,
    handleMenuOpen,
    setTypeFilter,
    anchorEl,
    filter,
    isLoading,
    data,
    t,
  };
};

export { useNotificationToolbar as default };
